export type QueryRoot = Document | Element;

export function select<T extends Element>(selector: string, root: QueryRoot = document): T | null {
  return root.querySelector<T>(selector);
}

export function selectAll<T extends Element>(selector: string, root: QueryRoot = document): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}
